import api from './api'
// import UserMainService from './userMainService'

class TodoService {
    // 获取所有todo数据（类型、周期、任务列表）
    static async getAllTodoData() {
        const response = await api.get('/usertodo/get_todo_data/')
        return response.data
    }

    // 添加新的任务类型或周期
    static async addTodoTypeOrCycle(data) {
        const response = await api.post('/usertodo/add_todo_type_or_cycle/', data)
        return response.data
    }

    // 更新任务类型或周期
    static async updateTodoTypeOrCycle(data) {
        const response = await api.post('/usertodo/update_todo_type_or_cycle/', data)
        return response.data
    }

    // 删除任务类型或周期
    static async deleteTodoTypeOrCycle(data) {
        const response = await api.post('/usertodo/delete_todo_type_or_cycle/', data)
        return response.data
    }

    // 添加新的任务项
    static async addTodoItem(data) {
        const response = await api.post('/usertodo/add_todo_item/', data)
        return response.data
    }

    // 更新任务项
    static async updateTodoItem(data) {
        const response = await api.post('/usertodo/update_todo_item/', data)
        // const response2 = await UserMainService.getAllApps(1)
        // console.log("in updateTodoItem, response2.data", response2)
        return response.data
    }

    // 删除任务项
    static async deleteTodoItem(data) {
        const response = await api.post('/usertodo/delete_todo_item/', data)
        return response.data
    }

    // 更新用户价值和价值历史记录
    static async updateWorth(data) {
        const response = await api.post('/usertodo/update_worth/', data)
        return response.data
    }

    // 获取用户价值信息
    static async getUserWorth() {
        const response = await api.get('/usertodo/get_user_worth/')
        return response.data
    }

    // 获取用户价值历史记录
    static async getUserWorthHistory() {
        const response = await api.get('/usertodo/get_user_worth_history/')
        return response.data
    }

    // 获取价值总排行榜数据
    static async getWorthRankingTotal() {
        const response = await api.get('/usertodo/get_worth_ranking_total/')
        return response.data
    }

    // 获取价值日排行榜数据
    static async getWorthRankingDaily() {
        const response = await api.get('/usertodo/get_worth_ranking_daily/')
        console.log("in getWorthRankingDaily, response.data", response.data)
        return response.data
    }

    // 获取价值周排行榜数据
    static async getWorthRankingWeekly() {
        const response = await api.get('/usertodo/get_worth_ranking_weekly/')
        return response.data
    }

    // 获取价值月排行榜数据
    static async getWorthRankingMonthly() {
        const response = await api.get('/usertodo/get_worth_ranking_monthly/')
        return response.data
    }

    // 获取价值年排行榜数据
    static async getWorthRankingYearly() {
        const response = await api.get('/usertodo/get_worth_ranking_yearly/')
        return response.data
    }
}

export default TodoService